import { createRouter, createWebHistory } from 'vue-router';
import { useAppStore } from './stores/app';
import { ApiError } from './lib/api';
import AppShell from './components/AppShell.vue';
import SettingsView from './views/SettingsView.vue';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/app' },
    { path: '/login', name: 'login', component: () => import('./views/LoginView.vue'), meta: { public: true } },
    {
      path: '/s/:shareToken',
      name: 'public-document',
      component: () => import('./views/PublicDocumentView.vue'),
      meta: { public: true },
    },
    {
      path: '/app',
      component: AppShell,
      children: [
        { path: '', name: 'dashboard', component: () => import('./views/DashboardView.vue') },
        { path: 'kb/:knowledgeBaseId', name: 'knowledge-base', component: () => import('./views/KnowledgeBaseView.vue') },
        {
          path: 'kb/:knowledgeBaseId/doc/:documentId',
          name: 'document',
          component: () => import('./views/EditorView.vue'),
        },
        {
          path: 'settings',
          component: SettingsView,
          children: [
            {
              path: '',
              name: 'settings',
              component: () => import('./views/SettingsOverviewView.vue'),
            },
            {
              path: 'members',
              name: 'users',
              component: () => import('./views/UsersView.vue'),
              meta: { admin: true },
            },
          ],
        },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/app' },
  ],
  scrollBehavior: () => ({ top: 0 }),
});

router.beforeEach(async (to) => {
  const store = useAppStore();

  if (!store.publicSettingsInitialized) {
    try {
      await store.loadPublicSettings();
    } catch {
      // 品牌配置加载失败时使用内置默认值，不阻断页面访问。
    }
  }

  if (to.meta.public && to.name === 'public-document') return true;

  if (!store.initialized) {
    try {
      await store.loadBootstrap();
    } catch (error) {
      if (!(error instanceof ApiError && error.status === 401)) throw error;
    }
  }

  if (to.meta.public) {
    return store.user && to.name === 'login' ? { name: 'dashboard' } : true;
  }
  if (!store.user) {
    return { name: 'login', query: { redirect: to.fullPath } };
  }
  if (to.meta.admin && !store.canManage) return { name: 'dashboard' };
  return true;
});
